/**
 * Recover from route chunks that no longer exist after a redeploy.
 *
 * A tab left open across a deploy still runs the old bundle, whose lazy route
 * imports point at hashed chunk names the new image no longer serves. The
 * import rejects, React.lazy caches that rejection, and the page stays broken
 * on every later visit until the user refreshes. Vite dispatches
 * `vite:preloadError` for exactly this failure; reloading fetches the current
 * index.html and its chunks. A per-chunk sessionStorage flag allows only one reload, so a chunk
 * that is genuinely missing falls through to the error boundary.
 */
const RELOAD_KEY = 'ensomirai:stale-chunk-reloaded:';

export function installStaleChunkReload(win: Window = window): void {
  win.addEventListener('vite:preloadError', (event) => {
    const chunk = String((event as Event & { payload?: Error }).payload?.message ?? '');
    const key = RELOAD_KEY + chunk;
    try {
      if (win.sessionStorage.getItem(key)) return;
      win.sessionStorage.setItem(key, '1');
    } catch {
      return; // without the flag a missing chunk could reload forever
    }
    event.preventDefault();
    win.location.reload();
  });
}
